import React from 'react';
import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditOutlined, ExperimentOutlined, ControlOutlined } from '@ant-design/icons';
import type { PlanAppMode } from '../../../../types/planManagement';

interface ModeSegmentProps {
  appMode: PlanAppMode;
  disablePlanningMode: boolean;
  disablePlantingMode: boolean;
  disableManagementMode: boolean;
  onAppModeChange: (mode: PlanAppMode) => void;
}

const ModeSegment: React.FC<ModeSegmentProps> = ({
  appMode,
  disablePlanningMode,
  disablePlantingMode,
  disableManagementMode,
  onAppModeChange,
}) => {
  const { t } = useTranslation('planning');
  return (
    <Segmented
      value={appMode}
      onChange={onAppModeChange as any}
      options={[
        ...(!disableManagementMode
          ? [{ label: t('modeSegment.management'), value: 'management', icon: <ControlOutlined /> }]
          : []),
        ...(!disablePlanningMode
          ? [{ label: t('modeSegment.planning'), value: 'planning', icon: <EditOutlined /> }]
          : []),
        ...(!disablePlantingMode
          ? [{ label: t('modeSegment.proTools'), value: 'planting', icon: <ExperimentOutlined /> }]
          : []),
      ]}
    />
  );
};

export default ModeSegment;
